import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/images/common/logo.svg'


const _hoisted_1 = { class: "l-header" }
const _hoisted_2 = { class: "p-header" }
const _hoisted_3 = { class: "p-header__container" }
const _hoisted_4 = { class: "p-header__brand" }
const _hoisted_5 = { class: "p-header__logo" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "SHUEISHA ID"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1)
const _hoisted_10 = [
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "p-header__nav p-header__nav--guest",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "p-header__navclose__btn" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "p-header__navttl" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "会員登録", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "ログイン", -1)
const _hoisted_17 = {
  key: 1,
  class: "p-header__nav",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "p-header__navclose__btn" }, null, -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "p-header__navitem p-header__user" }
const _hoisted_21 = { class: "p-header__user__img" }
const _hoisted_22 = ["src"]
const _hoisted_23 = { class: "p-header__user__name" }
const _hoisted_24 = { class: "p-header__navitem p-header__usermenu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SideMenu = _resolveComponent("SideMenu")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, { to: { name: 'Top' } }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          (_ctx.isDispSideMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "p-header__navbtn",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
              }, _hoisted_10))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["p-header__navmenu", { 'is-active':_ctx.isActiveRef }])
        }, [
          (!_ctx.loginStatus)
            ? (_openBlock(), _createElementBlock("nav", _hoisted_11, [
                _createElementVNode("div", {
                  class: "p-header__navclose",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                }, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_router_link, { to: { name: 'Top' } }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: _imports_0,
                        alt: "SHUEISHA ID",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", {
                  class: "p-header__navitem p-header__signup",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                }, [
                  _createVNode(_component_router_link, {
                    class: "c-btn",
                    to: { name: 'Signup' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", {
                  class: "p-header__navitem p-header__signin",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                }, [
                  _createVNode(_component_router_link, {
                    class: "c-link",
                    to: { name: 'Login' }
                  }, {
                    default: _withCtx(() => [
                      _hoisted_16
                    ]),
                    _: 1
                  })
                ])
              ]))
            : (_openBlock(), _createElementBlock("nav", _hoisted_17, [
                _createElementVNode("div", {
                  class: "p-header__navclose",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                }, _hoisted_19),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_router_link, {
                    class: "p-header__user__link",
                    to: { name: 'MypageTop' },
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isActiveRef = !_ctx.isActiveRef))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("img", {
                          src: _ctx.loginStatus && _ctx.store.state.userInfo.commonAttrInfo.imagePath ? _ctx.store.state.userInfo.commonAttrInfo.imagePath : require('@/assets/images/common/img_user-default.svg'),
                          alt: "User's profile image"
                        }, null, 8, _hoisted_22)
                      ]),
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.loginStatus && _ctx.nickName ? _ctx.nickName : 'User Name'), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_SideMenu, { onChangeIsActive: _ctx.changeIsActive }, null, 8, ["onChangeIsActive"])
                ])
              ]))
        ], 2)
      ])
    ])
  ]))
}